<template>
  <div>
    <small v-if="useDashboard" class="text-center text-secondary">
      Subir archivos: {{ fileTypesTitle }} | Máximo: {{ maxNumberOfFiles }} archivo{{ maxNumberOfFiles > 1 ? 's' : '' }}
    </small>
    <div v-show="useDashboard" id="uppy-target"></div>
    <input v-show="!useDashboard" type="file" id="my-file-input" />
  </div>
</template>

<script>
import Uppy from '@uppy/core'
import Dashboard from '@uppy/dashboard'
import AwsS3 from '@uppy/aws-s3'
// import FileInput from '@uppy/file-input'
import ThumbnailGenerator from '@uppy/thumbnail-generator'
import Spanish from '@uppy/locales/lib/es_ES'

export default {
  name: 'MixedUploader',
  props: {
    allowedFileTypes: {
      type: Array,
      required: false,
      default: () => ['.xlsx', '.pdf', '.csv', '.jpg', '.jpeg', '.png']
    },
    maxNumberOfFiles: {
      type: Number,
      default: 1
    },
    maxFileSize: {
      type: Number,
      default: 10 * 1024 * 1024 // 10MB
    },
    useDashboard: {
      type: Boolean,
      default: true
    },
    btnLabel: {
      type: String,
      default: 'Seleccionar archivos'
    },
    dashboardHeight: {
      type: Number,
      default: 300
    }
  },
  data () {
    return {
      locale: Spanish
    }
  },
  computed: {
    fileTypesTitle () {
      return this.allowedFileTypes.map(type => type.replace('.', '')).join(', ')
    }
  },
  mounted () {
    this.setupUppy()
  },
  methods: {
    setupUppy () {
      const uppy = Uppy({
        id: 'mixed-uploader',
        autoProceed: true,
        restrictions: {
          maxFileSize: this.maxFileSize,
          maxNumberOfFiles: this.maxNumberOfFiles,
          allowedFileTypes: this.allowedFileTypes
        },
        locale: this.locale
      })
        .use(AwsS3, { companionUrl: '/' })

      if (this.useDashboard) {
        uppy.use(Dashboard, {
          inline: true,
          target: '#uppy-target',
          height: this.dashboardHeight,
          showProgressDetails: true,
          showRemoveButtonAfterComplete: true,
          proudlyDisplayPoweredByUppy: false,
          note: `Archivos permitidos: ${this.fileTypesTitle}`,
          locale: this.locale,
          doneButtonHandler: () => {
            this.$emit('handle-done-button')
            uppy.cancelAll()
          }
        })
      } else {
        // Default input mode
        // uppy.use(FileInput, {
        //   target: '#my-file-input',
        //   replaceTargetContent: false,
        //   locale: { strings: { chooseFiles: this.btnLabel } }
        // })
        const fileInput = document.querySelector('#my-file-input')

        fileInput.addEventListener('change', (event) => {
          const files = Array.from(event.target.files)
          files.forEach((file) => {
            try {
              uppy.addFile({
                source: 'file input',
                name: file.name,
                type: file.type,
                data: file,
              })
            } catch (err) {
              if (err.isRestriction) {
                console.log('Restriction error:', err)

              } else {
                console.error(err)
              }
            }
          })
        })
      }

      // Thumbnail Generator solo para imágenes
      uppy.use(ThumbnailGenerator, {
        thumbnailWidth: 400,
        waitForThumbnailsBeforeUpload: false
      })

      uppy.on('thumbnail:generated', (file, preview) => {
        this.$emit('preview-generated', { file, preview })
      })

      uppy.on('upload-success', (file, response) => {
        this.$emit('file-added', this.formatFile(file))
      })

      uppy.on('file-removed', (file, reason) => {
        if (reason === 'removed-by-user') {
          this.$emit('file-removed', this.formatFile(file))
        }
      })

      uppy.on('complete', result => {
        // console.log('Subida completada:', result)
      })
    },
    formatFile (file) {
      const uploadedFileData = JSON.stringify({
        id: file.meta.key.match(/^cache\/(.+)/)[1],
        storage: 'cache',
        metadata: {
          size: file.size,
          filename: file.name,
          mime_type: file.type
        }
      })

      const formData = {
        file_id: file.meta.key.match(/^cache\/(.+)/)[1],
        file: uploadedFileData,
        name: file.name,
        type: file.type,
        preview: file.preview
      }

      if (formData.type.startsWith('image/')) {
        formData.type = 'image'
        formData.image = uploadedFileData
        formData.caption = file.name
      } else {
        formData.type = 'document'
        formData.file = uploadedFileData
      }

      return formData
    }
  }
}
</script>

<style scoped>
#uppy-target {
  font-size: 13px;
}

#my-file-input {
  color: transparent; /* hides the filename text */
}

#my-file-input::file-selector-button {
  font-size: 13px;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

#my-file-input::file-selector-button:hover {
  background-color: #0056b3;
}

</style>
